// Coordinates for Indian destinations used in the map view
export interface DestinationCoord {
  lat: number;
  lng: number;
}

export const destinationCoordinates: Record<string, DestinationCoord> = {
  "North Goa": { lat: 15.5479, lng: 73.7615 },
  "South Goa": { lat: 15.2832, lng: 74.0855 },
  "Jaipur": { lat: 26.9124, lng: 75.7873 },
  "Udaipur": { lat: 24.5854, lng: 73.7125 },
  "Jodhpur": { lat: 26.2389, lng: 73.0243 },
  "Jaisalmer": { lat: 26.9157, lng: 70.9083 },
  "Pushkar": { lat: 26.4898, lng: 74.5511 },
  "Manali": { lat: 32.2396, lng: 77.1887 },
  "Shimla": { lat: 31.1048, lng: 77.1734 },
  "Dharamshala": { lat: 32.2190, lng: 76.3234 },
  "Kasol": { lat: 32.0098, lng: 77.3142 },
  "Spiti Valley": { lat: 32.2461, lng: 78.0349 },
  "Munnar": { lat: 10.0889, lng: 77.0595 },
  "Alleppey": { lat: 9.4981, lng: 76.3388 },
  "Wayanad": { lat: 11.6854, lng: 76.1320 },
  "Kochi": { lat: 9.9312, lng: 76.2673 },
  "Rishikesh": { lat: 30.0869, lng: 78.2676 },
  "Mussoorie": { lat: 30.4598, lng: 78.0644 },
  "Nainital": { lat: 29.3803, lng: 79.4636 },
  "Auli": { lat: 30.5276, lng: 79.5660 },
  "Coorg": { lat: 12.3375, lng: 75.8069 },
  "Bangalore": { lat: 12.9716, lng: 77.5946 },
  "Hampi": { lat: 15.3350, lng: 76.4600 },
  "Gokarna": { lat: 14.5479, lng: 74.3188 },
  "Srinagar": { lat: 34.0837, lng: 74.7973 },
  "Gulmarg": { lat: 34.0484, lng: 74.3805 },
  "Pahalgam": { lat: 34.0161, lng: 75.3150 },
  "Ooty": { lat: 11.4102, lng: 76.6950 },
  "Kodaikanal": { lat: 10.2381, lng: 77.4892 },
  "Pondicherry": { lat: 11.9416, lng: 79.8083 },
  "Shillong": { lat: 25.5788, lng: 91.8933 },
  "Cherrapunji": { lat: 25.2726, lng: 91.7323 },
  "Lonavala": { lat: 18.7546, lng: 73.4062 },
  "Mahabaleshwar": { lat: 17.9307, lng: 73.6477 },
  "Gangtok": { lat: 27.3389, lng: 88.6065 },
  "Pelling": { lat: 27.3000, lng: 88.2333 },
  "Leh": { lat: 34.1526, lng: 77.5771 },
  "Nubra Valley": { lat: 34.6856, lng: 77.5667 },
  "Hyderabad": { lat: 17.3850, lng: 78.4867 },
  "Warangal": { lat: 17.9784, lng: 79.5941 },
  "Visakhapatnam": { lat: 17.6868, lng: 83.2185 },
  "Tirupati": { lat: 13.6288, lng: 79.4192 },
  "Araku Valley": { lat: 18.3274, lng: 82.8756 },
  "Nagarjuna Sagar": { lat: 16.5729, lng: 79.3124 },
};
